import escapeHTML from 'lodash/string/escape';
import jsdk from '../../jsdk';
import t from 'tcomb';
import Movie_Component_Style from './style/Movie_Component_Style';
import Natural from './Natural';
import { template } from '../../template';

// Rappresenta una componente video (solo YouTube per ora)
const Movie_Component = t.struct({
  style: Movie_Component_Style,
  src: t.Str,
  width: t.maybe(Natural),
  height: t.maybe(Natural)
}, 'Movie_Component');

Movie_Component.prototype.to_form = function() {
  var tmpl = template([
    '<div<%= attrs %>>',
    '<object width="<%= width %>" height="<%= height %>" data="<%= src %>">',
    '</object>',
    '</div>'
  ].join(''));
  return tmpl({
    attrs: jsdk.attr({
      style: this.style
    }),
    src: escapeHTML('https://www.youtube.com/embed/' + this.src + '?rel=0'),
    width: '100%', //this.width,
    height: '300' //this.height
  });
};

export default Movie_Component;


/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/domain/Movie_Component.js
 **/